// latest: zhangmyh 2017-12-21 1:55 PM
import { findIndex, isFunction } from 'lodash'
/* global ko */

export default function (params) {
  this.field = params.config.field
  this.model = params.row.model
  let realRow = params.row.row
  this.realModel = realRow
  this.state = params.row.model.ref('ag_changed')
  this.maxLength = 1000

  let datatype = params.config.editType
  this.editable = (params.config.editable === true || params.config.editable === false)
    ? params.config.editable : !!(params.editable)
  if (params.config.editType) {
    datatype = params.config.editType.toLowerCase()
  } else if (params.config.dataType) {
    datatype = params.config.dataType.toLowerCase()
  }

  if (params.config.editOptions && params.config.editOptions.maxLength) {
    this.maxLength = params.config.editOptions.maxLength
  }

  if (datatype == 'row') {
    if (params.row.rowType) {
      let _rowType = params.row.rowType
      let _editType = _rowType.editType
      if (_editType == 'number') {
        datatype = 'integer'
      } else if (_editType == 'string') {
        datatype = 'string'
      }
      else if (_editType == 'hansong') {
          datatype = 'hansong'
      } else if (_editType == 'combo') {
        datatype = 'combo'
        if (!params.config.editOptions) {
          params.config.editOptions = {}
        }
        params.config.editOptions.datasource = _rowType.options
      }
      if (_rowType.maxLength) {
        this.maxLength = _rowType.maxLength
      } else {
        // 后台数据库长度为200
        this.maxLength = 200
      }
    } else {
      datatype = 'string'
    }
  }

  if (datatype == 'action') {
    let oplist = []
    params.config.item.forEach(function (func) {
      if (func.hidden && func.hidden(realRow)) {
        return
      }
      // const click = partial(func.handler, realRow, func.callback)
      oplist.push({
        text: func.text,
        handler: function () {
          func.handler(realRow, func.callback)
        }
      })
    })
    this.oplist = oplist
  } else {
    if (datatype == 'date') {
      let _data = this.model.getValue(this.field)
      if (_data && _data !== null) {
        _data = _data.substr(0, 10)
        this.model.setValue(this.field, _data)
      }
    } else if (datatype == 'integer' || datatype == 'float' || datatype == 'percent' || datatype == 'hansong') {
      let _data = this.model.getValue(this.field)
      if (isNaN(_data)) {
        this.model.setValue(this.field, '')
      }
    } else if (datatype == 'bool') {
      let checkboxdata = [
        { value: '1', name: '&nbsp;' }
      ]
      this.checkboxData = checkboxdata
    }
    this.data = this.model.ref(this.field)
  }

  if (datatype == 'combo' || datatype == 'date') {
    this.model.on(this.field + '.valuechange', function ({ newValue }) {
      realRow.setValue(params.config.field, newValue)
    })
    if (datatype == 'combo') {
      const combodata = params.config.editOptions.datasource.map(function (ds) {
        return {
          value: ds.value + '',
          name: ds.name + ''
        }
      })
      this.getComboData = function (value) {
        if (value !== undefined) {
          let idx = findIndex(combodata, ['value', value + ''])
          return (idx >= 0) ? combodata[idx].name : ''
        }
        return combodata
      }
      if (!this.editable) {
        this.data = this.getComboData(this.model.getValue(this.field))
      }
    } else {
      if (params.config.editOptions) {
        if (params.config.editOptions.minDate) {
          if (isFunction(params.config.editOptions.minDate)) {
            this.minDate = params.config.editOptions.minDate
          } else {
            this.minDate = ko.observable(params.config.editOptions.minDate)
          }
        } else if (params.config.editOptions.minDateField) {
          this.minDate = this.model.ref(params.config.editOptions.minDateField)
        } else {
          this.minDate = ko.observable('')
        }
        if (params.config.editOptions.maxDate) {
          if (isFunction(params.config.editOptions.maxDate)) {
            this.maxDate = params.config.editOptions.maxDate
          } else {
            this.maxDate = ko.observable(params.config.editOptions.maxDate)
          }
        } else if (params.config.editOptions.maxDateField) {
          this.maxDate = this.model.ref(params.config.editOptions.maxDateField)
        } else {
          this.maxDate = ko.observable('')
        }
      } else {
        this.minDate = ko.observable('')
        this.maxDate = ko.observable('')
      }
    }
  } else if (datatype == 'bool') {
    let checkValue, uncheckValue
    if (params.config.editOptions && params.config.editOptions.checkValue) {
      checkValue = params.config.editOptions.checkValue
      uncheckValue = params.config.editOptions.uncheckValue
    } else {
      checkValue = '1'
      uncheckValue = '0'
    }
    if (this.editable) {
      this.model.on(this.field + '.valuechange', function ({ newValue }) {
        realRow.setValue(params.config.field, (newValue == '1') ? checkValue : uncheckValue)
      })
      this.text = 'bool'
    } else {
      this.text = (realRow.getValue(this.field) == checkValue) ? '√' : '×'
    }
  } else {
    let dataFormat = function () {
      return true
    }
    if (params.config.editOptions && params.config.editOptions.dataFormat) {
      dataFormat = params.config.editOptions.dataFormat
    }
    this.converseData = () => {
      let newValue = this.data()
      let data = realRow.ref(this.field)
      let oldValue = data()
      if (oldValue === null) {
        oldValue = ''
      }
      if (!newValue || newValue == '') {
        newValue = null
      } else {
        newValue = newValue + ''
        if (datatype == 'integer') {
          if (isNaN(newValue) || !newValue.match(/^\d*$/)) {
            this.data(oldValue)
            return
          }
        } else if (datatype == 'hansong') {
            if (!newValue.match(/^\d*-*\d*$/)) {
                this.data(oldValue)
                return
        } 
        }else if (datatype == 'float') {
          if (isNaN(newValue) || !newValue.match(/^(-)?(([1-9]\d*)|0)(\.\d\d*)?$/)) {
            this.data(oldValue)
            return
          }
          if (!newValue.match(/^(-)?(([1-9]\d*)|0)(\.\d\d?)?$/)) {
            newValue = newValue.substring(0, newValue.indexOf('.') + 3)
            this.data(newValue)
          }
        } else if (datatype == 'percent') {
          if (newValue === '100' || newValue.match(/^100(\.\d\d*)?$/)) {
          } else if (isNaN(newValue) || !newValue.match(/^(([1-9]\d?)|0)(\.\d\d*)?$/)) {
            this.data(oldValue)
            return
          }
          if (newValue == '100' || newValue.length < 3) {
            this.data(newValue)
          } else if (newValue.match(/^100(\.\d\d*)?$/)) {
            this.data('100')
          } else if (newValue.indexOf('.') > 0) {
            let pos = newValue.indexOf('.')
            let part = newValue.substr(pos + 1)
            if (part.indexOf('00') == 0) {
              newValue = newValue.substring(0, pos)
            } else {
              newValue = newValue.substring(0, pos + 3)
            }
            this.data(newValue)
          }
        } else if (datatype == 'email') {
          if (!newValue.match(/^(\w|-){1,30}@(\w|-){1,50}\.(\w|-){1,15}(\.(\w|-){1,15})?$/)) {
            this.data(oldValue)
            return
          }
        }

        // 自定义格式
        let formatFlag = dataFormat(newValue, oldValue, this.field, realRow)
        if (formatFlag === false) {
          this.data(oldValue)
          return
        } else if (formatFlag === true) {
        } else if (formatFlag) {
          newValue = formatFlag
          this.data(newValue)
        }
      }
      data(newValue)
    }
  }
  this.type = datatype
}



// WEBPACK FOOTER //
// ./src/components/ag-grid/cell/index.js